module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We owe an immense debt to the legions of historians, biographers, and memoirists who have written about World War I. We were assisted in our search for information by the unusually competent reference staff of the Margaret I. King Library at the University of Kentucky, and we gratefully acknowledge their help. We are also grateful for assistance from the staff of the Prints and Photographs Division of the Library of Congress and especially to Peter Harrington, curator of the Anne S.K. Brown Military Collection at Brown University. We also much appreciate the assent of Academy Chicago Publishers for permission to reproduce the maps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As is ever the case, we could not function without the loving support of our families, for which we can express only our pitifully inadequate thanks.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 75
// module chunks = 0